import { Flex, Grid, GridItem, Text } from '@everlywell/ui-kit';
import React, { useId } from 'react';

export type ListWithIconsProps = {
  options: ListItemProps[];
};

/**
 * Render a list of items with icons.
 */
function ListWithIcons(props: ListWithIconsProps): JSX.Element {
  const id = useId();
  return (
    // FIXME: alignEdges seems to be working only when spacing props is passed
    <Grid
      as="ul"
      listStyleType="none"
      columns={[1, 2]}
      alignEdges
      spacing={[4, 6]}
    >
      {props.options.map((option, index) => (
        <ListItem key={`${id}-${index}`} {...option} />
      ))}
    </Grid>
  );
}

export default ListWithIcons;

export type ListItemProps = {
  icon: React.ReactNode;
  text: React.ReactNode;
};

function ListItem(props: ListItemProps) {
  return (
    <GridItem as="li">
      <Flex gap={2} alignItems="center">
        {props.icon}
        <Text as="div" size="lg" color="tints.darkGrey">
          {props.text}
        </Text>
      </Flex>
    </GridItem>
  );
}
